import { useQuery } from '@apollo/client';
import { GET_APPLICABLE_REPORT_CARD_SCHEMA } from '../queries/report-card-schema.queries';
import { useLogQueryError } from '../hooks/use-log-query-error';

export const useGetApplicableReportCardSchema = (variables: {
  assessmentId?: string;
  ageGroupId?: string;
  positionId?: string;
  token?: string;
}) => {
    const { data, ...rest } = useQuery(GET_APPLICABLE_REPORT_CARD_SCHEMA, {
      variables,
      fetchPolicy: 'cache-and-network'
    });

    useLogQueryError(rest.error, 'getApplicableReportCardSchema');

    return {
      ...rest,
      data: data?.getApplicableReportCardSchema || null
    };
}